import React from "react";
import LoadingBar from "react-top-loading-bar";

export default function Loader({ setProgress, progress }) {
  return (
    <LoadingBar
      color="#481053"
      progress={progress}
      onLoaderFinished={() => setProgress(0)}
    />
  );
}
